import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { FeatureFlags } from '@/helpers/featureFlags'
import { useListingNote } from '@/queries/listingNotesQuery'

/**
 * The buyer's active note on a listing whether or not it is watched, read
 * only while both ENABLE_LISTING_NOTES and NOTES_OUTLIVE_WATCHLIST are on.
 * With either flag off it makes no request and returns undefined, so the
 * caller keeps today's watched-only display.
 */
export const useOutlivedListingNote = (
  personId: string | undefined,
  listingId: string
): string | undefined => {
  const enableListingNotes = useFlag(FeatureFlags.ENABLE_LISTING_NOTES)
  const notesOutliveWatchlist = useFlag(FeatureFlags.NOTES_OUTLIVE_WATCHLIST)
  const readsNote = enableListingNotes && notesOutliveWatchlist
  const { data } = useListingNote(readsNote ? personId : undefined, listingId)
  if (!readsNote) return undefined
  return data?.note || undefined
}

/**
 * Whether the LDP must hide a stored note: the listing is not watched and
 * NOTES_OUTLIVE_WATCHLIST is off, so only today's watched-only display holds
 * (FR-016). A note kept by an earlier flag-on removal stays hidden.
 */
export const useHidesUnwatchedNote = (
  isWatchlisted: boolean | undefined
): boolean => {
  const notesOutliveWatchlist = useFlag(FeatureFlags.NOTES_OUTLIVE_WATCHLIST)
  return !notesOutliveWatchlist && !isWatchlisted
}
